<template>
  <div class="table--wrapper" :class="{ 'overflow': overflow }">
    
    <table 
      v-if="hasMpaPrice"
      class="table has-tiny-font mt-3 mb-4"
      :class="{ 'overflow': overflow, 'is-fullwidth': !overflow}">

      <thead>
        <tr class="has-text-centered is-size-6">
          <th
            v-for="(header, i) in headers"
            :key="i"
            :class="header.class">
            <div v-html="header.label"></div>
          </th>
        </tr>
      </thead>

      <tbody>
        <template v-for="(row, i) in possibleTaxIncentiveMpa">
          <tr
            class="v-centered has-text-centered"
            :key="i">
            <td class="capitalize has-text-weight-bold">
              {{ row.year_name }} 
            </td>
            <td>
              <div class="has-text-weight-bold">
                {{ row.depreciation_43_1 | commasep(0, true) }}
              </div>
              <div>
                {{ row.value_to_depreciate_43_1 | commasep(0, true) }} x 
                {{ row.pct_43_1 | percentage }}
              </div>
            </td>
            <td>
              <div class="has-text-weight-bold">
                {{ row.depreciation_43_2 | commasep(0, true) }}
              </div>
              <div>
                {{ row.value_to_depreciate_43_2 | commasep(0, true) }} x 
                {{ row.pct_43_2 | percentage }}
              </div>
            </td>
            <td>
              <div v-if="row.year_name == 'Year 1'">
                <div class="has-text-weight-bold">
                  {{ row.depreciation_enhanced | commasep(0, true) }}
                </div>
                <div>
                  {{ row.value_to_depreciate_enhanced | commasep(0, true) }} x 
                  {{ row.pct_enhanced | percentage }}
                </div>
              </div>
            </td>
          </tr>
        </template>
      </tbody>

      <tfoot>
        <tr class="v-centered has-text-centered">
          <td>
            Total CCA In the first 3 years
          </td>
          <td>
            {{ possibleTaxIncentiveMpa.map(d => d.depreciation_43_1).reduce((a,b) => +a + +b, 0) | commasep(0, true) }}
          </td>
          <td>
            {{ possibleTaxIncentiveMpa.map(d => d.depreciation_43_2).reduce((a,b) => +a + +b, 0) | commasep(0, true) }}
          </td>
          <td>
            {{ possibleTaxIncentiveMpa.map(d => d.depreciation_enhanced).reduce((a,b) => +a + +b, 0) | commasep(0, true) }}
          </td>
        </tr>
      </tfoot>

    </table>

    <table 
      v-if="hasDpaPrice"
      class="table has-tiny-font mt-3 mb-4"
      :class="{ 'overflow': overflow, 'is-fullwidth': !overflow}">

      <thead>
        <tr class="has-text-centered is-size-6">
          <th
            v-for="(header, i) in headers"
            :key="i"
            :class="header.class">
            <div v-html="header.label"></div>
          </th>
        </tr>
      </thead>

      <tbody>
        <template v-for="(row, i) in possibleTaxIncentiveDpa">
          <tr
            class="v-centered has-text-centered"
            :key="i">
            <td class="capitalize has-text-weight-bold">
              {{ row.year_name }} 
            </td>
            <td>
              <div class="has-text-weight-bold">
                {{ row.depreciation_43_1 | commasep(0, true) }}
              </div>
              <div>
                {{ row.value_to_depreciate_43_1 | commasep(0, true) }} x 
                {{ row.pct_43_1 | percentage }}
              </div>
            </td>
            <td>
              <div class="has-text-weight-bold">
                {{ row.depreciation_43_2 | commasep(0, true) }}
              </div>
              <div>
                {{ row.value_to_depreciate_43_2 | commasep(0, true) }} x 
                {{ row.pct_43_2 | percentage }}
              </div>
            </td>
            <td>
              <div v-if="row.year_name == 'Year 1'">
                <div class="has-text-weight-bold">
                  {{ row.depreciation_enhanced | commasep(0, true) }}
                </div>
                <div>
                  {{ row.value_to_depreciate_enhanced | commasep(0, true) }} x 
                  {{ row.pct_enhanced | percentage }}
                </div>
              </div>
            </td>
          </tr>
        </template>
      </tbody>

      <tfoot>
        <tr class="v-centered has-text-centered">
          <td>
            Total CCA In the first 3 years
          </td>
          <td>
            {{ possibleTaxIncentiveDpa.map(d => d.depreciation_43_1).reduce((a,b) => +a + +b, 0) | commasep(0, true) }}
          </td>
          <td>
            {{ possibleTaxIncentiveDpa.map(d => d.depreciation_43_2).reduce((a,b) => +a + +b, 0) | commasep(0, true) }}
          </td>
          <td>
            {{ possibleTaxIncentiveDpa.map(d => d.depreciation_enhanced).reduce((a,b) => +a + +b, 0) | commasep(0, true) }}
          </td>
        </tr>
      </tfoot>

    </table>

  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    estimation: {
      type: Object
    },
    hasMpaPrice: {
      type: Boolean,
      default: true
    },
    hasDpaPrice: {
      type: Boolean,
      default: true
    },
    overflow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      headers: [
        { label: 'YEAR' },
        { label: 'CCA FOR CLASS 43.1 ($)' },
        { label: 'CCA FOR CLASS 43.2 ($)' },
        { label: 'FIRST YEAR ENHANCED CCA ($)' }
      ]
    }
  },
  computed: {
    possibleTaxIncentiveMpa({ estimation }) {
      return estimation.estimation_summary.possible_tax_incentive
    },
    possibleTaxIncentiveDpa({ estimation }) {
      return estimation.estimation_summary_dpa.possible_tax_incentive
    }
  },
  methods: {
    getTotal(field, subtract) {
      let tot = this.summaryObject.summary.map(
        d => d[field]
      ).reduce((a, b) => a + +b, 0);

      if (!subtract) {
        return tot;
      } else {
        let diff = this.summaryObject.summary.map(
          d => d[subtract]
        ).reduce((a, b) => a + +b, 0);

        return -(tot - diff);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/flexbox.scss';
@import '@/styles/table.scss';

$overflow-margin: -35px;

.table--wrapper {
  position: relative;
  break-inside: avoid;
  &.overflow {
    left: $overflow-margin;
  }
}

.table {
  position: relative;
  left: 0px;
  top: 0px;
  break-inside: avoid;

  &.overflow {
    width: calc(
      var(--pagedjs-width) - 
      var(--pagedjs-margin-right) - 
      var(--pagedjs-margin-left) + 70px
    );
  } 

  th {
    color: #fff;
    background: #0E4E74;
    font-size: 0.7em !important;

    .unit {
      color: #F16635;
    }
  }

  tbody {
    td:first-child {
      color: #0E4E74;
      background: #E6ECF2;
    }
  }
  
  .is-size-teeny {
    font-size: 0.6em !important;
  }

  tfoot {
    td {
      color: #fff;
    }
    background: #0E4E74;
  }
}

.capitalize {
  text-transform: capitalize;
}

.uppercase {
  text-transform: uppercase;
}
</style>